import { Box, Chip, IconButton, Tab, Tabs, Typography } from "@mui/material";
import MaterialTable from "material-table";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  ConvertDate,
  getImageSignedUrl,
} from "../../../../Base/helper/baseFunctions";
import { useDispatch, useSelector } from "react-redux";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { GetApproverExpenseAction } from "../../../../../../store/Finance/Expense/Action";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Popup from "../../../../Base/views/Popup";
import ExpenseApprovedPopUp from "../../../helper/HelperComponents/ExpenseApprovedPopUp";
const ExpenseAdminPage = () => {
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const { approver_expenses, approverExpenseLoading } = useSelector(
    (state) => state?.FinanceReducer?.ExpenseReducer
  );
  const [openPopup, setOpenPopup] = useState(false);
  const [editedRecord, setEditedRecord] = useState(null);

  const handleEdit = (rowData) => {
    setEditedRecord(rowData);
    setOpenPopup(true);
  };
  const closeMode = (resetForm) => {
    setEditedRecord(null);
    setOpenPopup(false);
  };

  const handleChange = (event, newValue) => {
    setLoading(true);
    setValue(newValue);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const getFilteredData = () => {
    switch (value) {
      case 0:
        return approver_expenses?.filter(
          (row) =>
            row?.finance_approver_status === "Pending Approval" ||
            row?.finance_approver_status === "Action Needed"
        );
      case 1:
        return approver_expenses?.filter(
          (row) =>
            row?.finance_approver_status === "Approved" ||
            row?.finance_approver_status === "Rejected" ||
            row?.finance_approver_status === "Self Approved"
        );
      default:
        return approver_expenses;
    }
  };

  useEffect(() => {
    dispatch(GetApproverExpenseAction());
  }, [dispatch]);

  const handleView = async (event, rowData) => {
    event.stopPropagation();
    let filename = rowData?.proof;

    try {
      const url = await getImageSignedUrl(filename);
      if (filename.endsWith(".doc") || filename.endsWith(".docx")) {
        window.open(
          `https://docs.google.com/viewer?url=${encodeURIComponent(
            url
          )}&embedded=true`,
          "_blank"
        );
      } else {
        window.open(url, "_blank");
      }
      return url;
    } catch (err) {
      toast.error(err);
    }
  };

  const getExpenseTableTitle = (value) => {
    if (value === 0) {
      return (
        <Box>
          <Typography variant="h6" fontWeight={600}>
            Expenses Requiring Action
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Review and approve/reject pending expense claims
          </Typography>
        </Box>
      );
    } else if (value === 1) {
      return (
        <Box>
          <Typography variant="h6" fontWeight={600}>
            Settled Expenses
          </Typography>
          <Typography variant="body2" color="text.secondary">
            View all processed expense claims and their status
          </Typography>
        </Box>
      );
    } else {
      return (
        <Typography variant="h6" fontWeight={600}>
          Expenses
        </Typography>
      );
    }
  };

  return (
    <Box>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        sx={{
            minHeight: "40px", mb: 1, ".MuiTab-root": { minHeight: "20px" },
            '& .MuiTabs-indicator': {
                width: '100%',
                display: 'flex',
                justifyContent: "center !important",
            },
        }} 
      >
        <Tab label={`Action Required`} {...a11yProps(0)} />
        <Tab label={`All Settled`} {...a11yProps(1)} />
      </Tabs>
      <Box
        sx={{
          borderRadius: "10px",
          maxHeight: "calc(100vh - 155px)",
          overflowY: "auto",
        }}
      >
        <MaterialTable
          columns={[
            { title: "Employee", field: "employee_name", headerStyle: { cursor: "pointer" } },
            { title: "Category", field: "expense_name", headerStyle: { cursor: "pointer" } },
            {
              title: "Subcategory",
              field: "sub_expense_type_name",
              headerStyle: { cursor: "pointer" },
            },
            {
              title: "Date",
              field: "entry_date",
              headerStyle: { cursor: "pointer" },
              render: (data) => ConvertDate(data?.entry_date),
            },
            {
              title: "Claimed Amount",
              field: "employee_amount",
              headerStyle: { cursor: "pointer" },
            },
            {
              title: "Approved Amount",
              hidden: value === 0,
              field: "finance_approver_amount",
              headerStyle: { cursor: "pointer" },
              render: (rowData) => rowData?.finance_approver_amount ? rowData?.finance_approver_amount : "-",
            },
            {
              field: "proof",
              title: "Preview Proof",
              sorting: false,
              headerStyle: {
                padding: "5px 0px 5px 10px",
                textAlign: "start",
                cursor: "default",
              },
              cellStyle: {
                textAlign: "start",
                padding: "5px 0px 5px 2%",
              },
              render: (rowData) => (
                <div onClick={(event) => event.stopPropagation()}>
                  {rowData.proof ? (
                    <IconButton onClick={(event) => handleView(event, rowData)}>
                      <VisibilityIcon />
                    </IconButton>
                  ) : (
                    "N/A"
                  )}
                </div>
              ),
            },
            {
              title: "Status",
              headerStyle: {
                textAlign: "center",
                cursor: "pointer",
              },
              cellStyle: {
                textAlign: "center",
              },
              field: "finance_approver_status",
              render: (rowData) => {
                const { bg, text } = getStatusColor(
                  rowData?.finance_approver_status
                );
                return (
                  <Box sx={{ textAlign: "start", pl: "10px" }}>
                    <Chip
                      label={rowData.finance_approver_status}
                      style={{
                        backgroundColor: bg,
                        color: text,
                        fontWeight: 500,
                      }}
                      size="small"
                    />
                  </Box>
                );
              },
            },
          ]}
          data={getFilteredData()}
          isLoading={approverExpenseLoading || loading}
          options={{
            maxBodyHeight: "calc(100vh - 280px)",
            minBodyHeight: "calc(100vh - 280px)",
            rowStyle: {
              fontSize: "13px",
              height: "35px",
            },
            cellStyle: {
              padding: "5px 0px 5px 13px",
            },
            headerStyle: {
              padding: "5px 10px 5px 10px",
              fontWeight: "bold",
            },
            sorting: true,
            search: true,
            searchText: "",
            searchFieldAlignment: "right",
            searchAutoFocus: false,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: false,
            exportAllData: false,
            exportFileName: "Employees",
            addRowPosition: "first",
            selection: false,
            actionsColumnIndex: -1,
            grouping: false,
            columnsButton: false,
          }}
          actions={
            value === 0
              ? [
                  {
                    icon: () => (
                      <IconButton sx={{ padding: "0px" }}>
                        <CheckCircleIcon color="primary" />
                      </IconButton>
                    ),
                    tooltip: "Approve/Reject",
                    onClick: (_event, rowData) => {
                      _event.stopPropagation();
                      handleEdit(rowData);
                    },
                  },
                ]
              : []
          }
          title={getExpenseTableTitle(value)}
        />
        <Popup
          title={"Approve/Reject"}
          openPopup={openPopup}
          setOpenPopup={closeMode}
          fullWidth={true}
          maxWidth="xs"
        >
          <ExpenseApprovedPopUp
            editedRecord={editedRecord}
            closeMode={closeMode}
          />
        </Popup>
      </Box>
    </Box>
  );
};

export default ExpenseAdminPage;

const getStatusColor = (status) => {
  switch (status) {
    case "Pending Approval":
    case "Action Needed":
      return { bg: "#FFF4E5", text: "#FFA726" }; // yellow
    case "Approved":
    case "Self Approved":
      return { bg: "#E8F5E9", text: "#66BB6A" }; // green
    case "Rejected":
      return { bg: "#FFEBEE", text: "#EF5350" }; // red
    default:
      return { bg: "#E5E7EB", text: "#374151" }; // gray
  }
};
